import { Collapse, TextField, FormControlLabel, Checkbox, Select, MenuItem } from "@mui/material";
import React from "react";
import palette from "../../../../../../config/colorPalette";
import { clone } from "ramda";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { handleChannelDisability } from "../utils";
import ModalChannelInfo from "./modalChannelInfo";

const ChannelInfo = ({
  e,
  equipment,
  setEquipment,
  channelPK,
  equipmentInterMeasurement,
  setEquipmentInterMeasurement,
  channelNameAsignToggle,
  channelDataToggle,
  setChannelDataToggle,
  setChannelNameAsignToggle,
  channelAsignToggle,
  setChannelAsignToggle,
  substructureDataToggle,
  setSubstructureDataToggle,
  zones,
  setZones,
  zoneToggle,
  setZoneToggle,
  thresholdsRanges,
  indexEquipment,
  polylineDisplay,
  useStyles,
  setChannelPK,
  setThresholdsRanges,
  polylineColors,
  hoveredPolylineIndex,
  setHoveredPolylineIndex,
  moreSubsAllowed,
  centroid,
  customCentroidIcon,
  customInclinometerIcon,
  customIcon,
  customShadowIcon,
  inclinometers,
  open,
  errors,
  setErrors,
  BootstrapButton,
  intl,
}) => {
  return (
    <>
      <BootstrapButton
        variant="contained"
        id="name-to-channels"
        onClick={() => {
          let newChannel = clone(channelNameAsignToggle);
          if (newChannel[indexEquipment]) {
            newChannel[indexEquipment] = false;
          } else {
            newChannel[indexEquipment] = true;
          }
          setChannelNameAsignToggle(newChannel);
        }}
      >
        {intl.formatMessage({ id: "channel.names" })}
        {!channelNameAsignToggle[indexEquipment] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
      </BootstrapButton>
      <Collapse in={channelNameAsignToggle[indexEquipment]}>
        {e.channels.map((channel, indChan) => {
          return (
            <ModalChannelInfo
              BootstrapButton={BootstrapButton}
              channelAsignToggle={channelAsignToggle}
              channelDataToggle={channelDataToggle}
              channelNameAsignToggle={channelNameAsignToggle}
              channelPK={channelPK}
              e={e}
              equipment={equipment}
              equipmentInterMeasurement={equipmentInterMeasurement}
              errors={errors}
              hoveredPolylineIndex={hoveredPolylineIndex}
              indChan={indChan}
              indexEquipment={indexEquipment}
              intl={intl}
              moreSubsAllowed={moreSubsAllowed}
              polylineColors={polylineColors}
              polylineDisplay={polylineDisplay}
              setChannelAsignToggle={setChannelAsignToggle}
              setChannelDataToggle={setChannelDataToggle}
              setChannelNameAsignToggle={setChannelNameAsignToggle}
              setChannelPK={setChannelPK}
              setEquipment={setEquipment}
              setEquipmentInterMeasurement={setEquipmentInterMeasurement}
              setErrors={setErrors}
              setHoveredPolylineIndex={setHoveredPolylineIndex}
              setThresholdsRanges={setThresholdsRanges}
              thresholdsRanges={thresholdsRanges}
              useStyles={useStyles}
              centroid={centroid}
              customCentroidIcon={customCentroidIcon}
              customInclinometerIcon={customInclinometerIcon}
              customIcon={customIcon}
              customShadowIcon={customShadowIcon}
              open={open}
              inclinometers={inclinometers}
              zoneToggle={zoneToggle}
              setZoneToggle={setZoneToggle}
              zones={zones}
              setZones={setZones}
              zoneSubToggle={substructureDataToggle}
              setZoneSubToggle={setSubstructureDataToggle}
            />
          );
        })}
      </Collapse>

      {/*    <Collapse in={channelAsignToggle[indexEquipment]}>
        {e.channels.map((channel, indChan) => {
          return (
            <div style={{ margin: "2%", display: "inline-block" }}>
              {indChan + 1}.
              <Select
                id={e.equipmentID + "channel" + indChan}
                onChange={(e) => {
                  const newEquipments = [...equipment];
                  const updatedEquipment = { ...newEquipments[indexEquipment] };
                  updatedEquipment.channels[indChan] = parseInt(e.target.value);
                  newEquipments[indexEquipment] = updatedEquipment;
                  let cloneRange = clone(thresholdsRanges);
                  for (
                    let indexEquipment = 0;
                    indexEquipment < Object.keys(thresholdsRanges).length;
                    indexEquipment++
                  ) {
                    for (
                      let indexMeasure = 0;
                      indexMeasure < thresholdsRanges[`equipment${indexEquipment + 1}`].length;
                      indexMeasure++
                    ) {
                      for (
                        let indexChannel = 0;
                        indexChannel < thresholdsRanges[`equipment${indexEquipment + 1}`][indexMeasure].length;
                        indexChannel++
                      ) {
                        if (indexChannel === indChan) {
                          for (
                            let indexZone = 0;
                            indexZone <
                            thresholdsRanges[`equipment${indexEquipment + 1}`][indexMeasure][indexChannel].length;
                            indexZone++
                          ) {
                            cloneRange[`equipment${indexEquipment + 1}`][indexMeasure][indexChannel][indexZone][1] =
                              Math.round(
                                polylineDisplay[parseInt(e.target.value)].points[
                                  polylineDisplay[parseInt(e.target.value)].points.length - 1
                                ].pk * 100,
                              ) / 100;
                          }
                        }
                      }
                    }
                  }
                  let newChannelPk = clone(channelPK);
                  newChannelPk[indexEquipment][indChan] =
                    Math.round(
                      polylineDisplay[parseInt(e.target.value)].points[
                        polylineDisplay[parseInt(e.target.value)].points.length - 1
                      ].pk * 100,
                    ) / 100;
                  updatedEquipment.channelsLength[indChan] = parseFloat(
                    Math.round(
                      polylineDisplay[parseInt(e.target.value)].points[
                        polylineDisplay[parseInt(e.target.value)].points.length - 1
                      ].pk * 100,
                    ) / 100,
                  );
                  setChannelPK(newChannelPk);
                  setThresholdsRanges(cloneRange);
                  setEquipment(newEquipments);
                }}
                defaultValue={channel}
              >
                {polylineDisplay.map((p, indPoly) => {
                  return (
                    <MenuItem
                      key={e.equipmentID + "channel" + indChan + "_" + indPoly}
                      value={indPoly}
                      onMouseOver={() => {
                        if (polylineDisplay.length > 10) {
                          setHoveredPolylineIndex(null);
                          setTimeout(() => {
                            setHoveredPolylineIndex(indPoly);
                          }, 0);
                        }
                      }}
                      onMouseOut={() => {
                        setHoveredPolylineIndex(null);
                      }}
                    >
                      {polylineDisplay.length > 10 ? (
                        <>{indPoly + 1}</>
                      ) : (
                        <div
                          className={useStyles.colorSample}
                          style={{
                            backgroundColor: polylineColors[indPoly],
                            width: "20px",
                            height: "20px",
                            display: "inline-block",
                            marginRight: "8px",
                            border: "1px solid #ccc",
                          }}
                        ></div>
                      )}
                    </MenuItem>
                  );
                })}
              </Select>
            </div>
          );
        })}
      </Collapse>*/}
    </>
  );
};

export default ChannelInfo;
